import SyntaxHighlighter from "react-syntax-highlighter";
import { nightOwl } from "react-syntax-highlighter/dist/esm/styles/hljs";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "./AppContext";
import Button from "./Button";
import "react-perfect-scrollbar/dist/css/styles.css";
import { printStyle } from "@/functions/fns";
import { icons } from "./icons";
import SVGAnimator from "./SVGAnimator";
import CopyToClipBoard from "./CopyToClipBoard";
var beautify = require("js-beautify/js");

export default function Exporter({ data }) {
	const ctx = useContext(AppContext);
	const { setShowExport } = ctx;
	const resource = data || ctx;
	const { config, bg, duration, animationType } = resource;
	const [code, setCode] = useState("");
	const [showAnimCode, setShowAnimCode] = useState(false);
	const [showStaticCode, setShowStaticCode] = useState(false);
	const aRef = useRef(null);
	const sRef = useRef(null);

	const selector = ".your_css_selector_here";

	const btnClass =
		"bg-dark-900 dark:bg-dark-100 px-3 text-white dark:text-dark-900";

	const headClass =
		"sticky top-0 z-50 p-3 border-y border-color z-20 bg-white dark:bg-dark-950";
	const boxClass = "p-2";
	const styleBox = "p-4 bg-dark-900 rounded relative";

	useEffect(() => {
		let newString = printStyle(
			config,
			"cocco",
			bg,
			duration,
			animationType
		);
		newString = newString
			.split("ani-cocco")
			.join("hero-gradient-animation");
		newString = newString.split("#cocco").join(selector);
		setCode(newString);
	}, [selector, config, animationType, bg, duration]);

	useEffect(() => {
		setShowAnimCode(false);
	}, [config, bg]);

	const animCode = aRef?.current && (
		<div className={styleBox + " mt-2"}>
			<CopyToClipBoard text={beautify.html(aRef.current.innerHTML)} />
			<SyntaxHighlighter
				wrapLongLines={true}
				language="html"
				style={nightOwl}
			>
				{beautify.html(aRef.current.innerHTML)}
			</SyntaxHighlighter>
		</div>
	);

	const info = (
		<div className="mb-2 rounded border border-accent-700/10 bg-accent-400/10 p-4 text-accent-500">
			Remember to replace{" "}
			<span className="text-accent-700">{selector}</span> with your
			desired css selector
		</div>
	);

	const staticCode = sRef?.current && (
		<div className={styleBox + " mt-2"}>
			<CopyToClipBoard text={beautify.html(sRef.current.innerHTML)} />
			<SyntaxHighlighter
				wrapLongLines={true}
				language="html"
				style={nightOwl}
			>
				{beautify.html(sRef.current.innerHTML)}
			</SyntaxHighlighter>
		</div>
	);

	return (
		<div className="border-color absolute left-full top-0 h-full w-[800px] overflow-hidden border-l bg-white dark:bg-dark-950">
			<div className="relative flex h-full flex-col">
				<div className="flex items-center justify-between">
					<div className="flex h-10 items-center p-2">
						<div className="text-dark-400">Export</div>
					</div>
					<div
						className="wu hu flexer cursor-pointer"
						onClick={() => setShowExport(false)}
					>
						{icons.close}
					</div>
				</div>
				<PerfectScrollbar
					options={{ wheelPropagation: false }}
					className=""
				>
					<div className={headClass}>Animated SVG</div>
					<div className="flex flex-1 flex-col">
						<div className={boxClass}>
							<div ref={aRef} className="overflow-hidden rounded">
								<SVGAnimator />
							</div>
							<div className="flex items-center justify-end pt-2">
								<div className="flex items-center gap-2">
									<Button
										onClick={() =>
											setShowAnimCode((e) => !e)
										}
										className={btnClass}
									>
										{icons.code}
										Code
									</Button>
								</div>
							</div>
							{showAnimCode && animCode}
						</div>
						<div className={headClass}>Static SVG</div>
						<div className={boxClass}>
							<div ref={sRef} className="overflow-hidden rounded">
								<SVGAnimator isStatic={true} />
							</div>
							<div className="flex items-center justify-end pt-2">
								<div className="flex items-center gap-2">
									<Button
										className={btnClass}
										onClick={() =>
											setShowStaticCode((e) => !e)
										}
									>
										{icons.code}
										Code
									</Button>
								</div>
							</div>
							{showStaticCode && staticCode}
						</div>
						<div className={headClass}>Minified CSS</div>
						<div className={boxClass}>
							{info}
							<div className={styleBox}>
								<CopyToClipBoard text={code} />
								<SyntaxHighlighter
									wrapLongLines={true}
									language="css"
									style={nightOwl}
								>
									{code}
								</SyntaxHighlighter>
							</div>
						</div>
						<div className={headClass}>Normal CSS</div>
						<div className={boxClass}>
							{info}
							<div className={styleBox}>
								<CopyToClipBoard text={beautify.css(code)} />
								<SyntaxHighlighter
									wrapLongLines={true}
									language="css"
									style={nightOwl}
								>
									{beautify.css(code)}
								</SyntaxHighlighter>
							</div>
						</div>
						{/* <div ref={aRef}>
							<SVGAnimator />
						</div>
						<div className="rounded bg-dark-900 p-2">
							<SyntaxHighlighter
								wrapLongLines={true}
								language="html"
								style={nightOwl}
							>
								{beautify.html(code.anim)}
							</SyntaxHighlighter>
						</div>
						<div ref={sRef}>
							<SVGAnimator isStatic={true} />
						</div>
						<div className="rounded bg-dark-900 p-2">
							<SyntaxHighlighter
								wrapLongLines={true}
								language="html"
								style={nightOwl}
							>
								{beautify.html(code.static)}
							</SyntaxHighlighter>
						</div> */}
					</div>
				</PerfectScrollbar>
			</div>
		</div>
	);
}
/* 
export default function Exporter({ data }) {
	const ctx = useContext(AppContext);
	const { setShowExport } = ctx;
	const resource = data || ctx;
	const { config, bg, duration, animationType } = resource;

	const [mode, setMode] = useState(0);
	const modes = ["minified", "normal"];
	const [codeString, setCodeString] = useState("");
	const [selector, setSelector] = useState(".myCSS_Selector");
	const [open, setOpen] = useState(false);

	const [code, setCode] = useState({ static: "", anim: "" });

	const [exportType, setExportType] = useState("svg");

	useEffect(() => {
		let newString = printStyle(
			config,
			"cocco",
			bg,
			duration,
			animationType
		);
		newString = newString
			.split("ani-cocco")
			.join("hero-gradient-animation");
		newString = newString.split("#cocco").join(selector);
		setCodeString(newString);
	}, [selector, config, animationType, bg, duration]);

	const minified = beautify(codeString);

	const btnCl = (cond) => {
		const w = cond
			? "bg-dark-400/20 text-dark-100"
			: "bg-dark-800 text-dark-400";
		return w + " cursor-pointer rounded px-5 py-2 capitalize";
	};

	const aRef = useRef(null);
	const sRef = useRef(null);

	useEffect(() => {
		if (sRef.current && aRef.current) {
			setCode({
				static: sRef.current.innerHTML,
				anim: aRef.current.innerHTML,
			});
		}
	}, [aRef.current, sRef.current]);

	return (
		<div className="absolute left-full top-0 h-full w-[800px] overflow-hidden bg-dark-50 p-2 pl-0 dark:bg-dark-900">
			<div className="relative flex h-full flex-col gap-2">
				<div className="flex items-center gap-2 ">
					Export Mode:
					{modes.map((m, i) => {
						return (
							<div
								key={i}
								onClick={() => {
									setExportType("css");
									setMode(i);
								}}
								className={btnCl(
									i === mode && exportType === "css"
								)}
							>
								{m} CSS
							</div>
						);
					})}
					<div
						className={btnCl(exportType === "svg")}
						onClick={() => setExportType("svg")}
					>
						SVG
					</div>
					<div
						className="flexer ml-auto h-8 w-8 cursor-pointer"
						onClick={() => setShowExport(false)}
					>
						{icons.close}
					</div>
				</div>
				<div className="relative overflow-hidden rounded-lg bg-dark-800">
					<PerfectScrollbar
						options={{ wheelPropagation: false }}
						className="p-2 text-sm"
					>
						{exportType === "css" ? (
							<SyntaxHighlighter
								wrapLongLines={true}
								language="html"
								style={darcula}
							>
								{mode === 1 ? minified : codeString}
							</SyntaxHighlighter>
						) : (
							<div className="bg-dark-800">
								<div ref={sRef}>
									<SVGAnimator />
								</div>
								<SyntaxHighlighter
									wrapLongLines={true}
									language="html"
									style={darcula}
								>
									{code.static}
								</SyntaxHighlighter>
								<div ref={aRef}>
									<SVGAnimator isStatic={true} />
								</div>
								<SyntaxHighlighter
									wrapLongLines={true}
									language="css"
									style={darcula}
								>
									{code.anim}
								</SyntaxHighlighter>
							</div>
						)}
					</PerfectScrollbar>
				</div>
			</div>
		</div>
	);
} */
